import { LayoutGroup, motion } from "motion/react";
import { Link, useLocation } from "react-router-dom";

import "./HeaderTabs.Component.scss";

interface Props {
  items: { to: string; label: string; excludeMatch?: string }[];
}

export function HeaderTabsComponent(props: Props) {
  return (
    <LayoutGroup>
      <div className="HeaderTabsComponent">
        {props.items.map((item, index) => (
          <HeaderTabsComponentItem key={index} to={item.to} excludeMatch={item.excludeMatch}>
            {item.label}
          </HeaderTabsComponentItem>
        ))}
      </div>
    </LayoutGroup>
  );
}

interface HeaderTabsComponentItemProps {
  children: React.ReactNode;
  to: string;
  useATag?: boolean;
  supressMatch?: boolean;
  excludeMatch?: string;
  selected?: boolean;
}

function HeaderTabsComponentItem(props: HeaderTabsComponentItemProps) {
  const Tag: any = props.useATag ? "a" : Link;
  let selected = props.selected;

  if (!props.supressMatch) {
    let location = useLocation();
    // Match on the path only — a `to` may carry a query string (e.g. scope params).
    const toPath = props.to.split("?")[0];

    if (location.pathname.indexOf(toPath) >= 0) {
      if (props.excludeMatch && location.pathname.indexOf(props.excludeMatch) > -1) {
        selected = false;
      } else {
        selected = true;
      }
    }
  }

  return (
    <Tag {...(props.useATag ? { href: props.to } : { to: props.to })} className={`HeaderTabsComponentItem ${selected ? "selected" : ""}`}>
      {selected && (
        <motion.div
          className="HeaderTabsComponentItem-highlight"
          layoutId="header-tab-highlight"
          transition={{ type: "spring", bounce: 0.15, duration: 0.4 }}
        />
      )}
      <span className="HeaderTabsComponentItem-label">{props.children}</span>
    </Tag>
  );
}
